import type {ServiceResponsePayload} from '@igp/shared/api';
import type {AsyncActionMeta} from '@igp/shared/redux/async-action';
import {createAsyncAction} from 'typesafe-actions';

import type {
    BoUserAddPayload,
    BoUserEditPayload,
    BoUserResetPasswordPayload,
    BoUserUnlinkAgentPayload,
    BoUserUpdateAccountStatusPayload,
} from './types';

const domain = 'bo-user';

export const boUserActions = {
    addUser: createAsyncAction(`${domain}/addUserRequest`, `${domain}/addUserSucceed`, `${domain}/addUserFailed`)<
        BoUserAddPayload,
        ServiceResponsePayload<BoUserAddPayload, string>,
        ServiceResponsePayload<BoUserAddPayload, unknown>
    >(),
    editUser: createAsyncAction(`${domain}/editUserRequest`, `${domain}/editUserSucceed`, `${domain}/editUserFailed`)<
        BoUserEditPayload,
        ServiceResponsePayload<BoUserEditPayload, unknown>,
        ServiceResponsePayload<BoUserEditPayload, unknown>
    >(),
    updateUserAccountStatus: createAsyncAction(
        `${domain}/updateUserAccountStatusRequest`,
        `${domain}/updateUserAccountStatusSucceed`,
        `${domain}/updateUserAccountStatusFailed`
    )<
        [BoUserUpdateAccountStatusPayload, AsyncActionMeta],
        [ServiceResponsePayload<BoUserUpdateAccountStatusPayload, unknown>, AsyncActionMeta],
        [ServiceResponsePayload<BoUserUpdateAccountStatusPayload, unknown>, AsyncActionMeta]
    >(),
    resetPassword: createAsyncAction(`${domain}/resetPasswordRequest`, `${domain}/resetPasswordSucceed`, `${domain}/resetPasswordFauled`)<
        BoUserResetPasswordPayload,
        ServiceResponsePayload<BoUserResetPasswordPayload, unknown>,
        ServiceResponsePayload<BoUserResetPasswordPayload, unknown>
    >(),
    unlinkAgent: createAsyncAction(`${domain}/unlinkAgentRequest`, `${domain}/unlinkAgentSucceed`, `${domain}/unlinkAgentFailed`)<
        [BoUserUnlinkAgentPayload, AsyncActionMeta],
        [ServiceResponsePayload<BoUserUnlinkAgentPayload, unknown>, AsyncActionMeta],
        [ServiceResponsePayload<BoUserUnlinkAgentPayload, unknown>, AsyncActionMeta]
    >(),
};
